import React, { useState } from 'react';
import { Button, Form, Input, Grid, Segment } from 'semantic-ui-react';

class Pagination extends React.Component {
    state = {
        gotoPage: this.props.currentPage
    };

    componentDidUpdate(prevProps) {
        if (prevProps.currentPage !== this.props.currentPage) {
            this.setState({ gotoPage: this.props.currentPage});
        }
    }

    handleJumpToPage = (e) => {
        e.preventDefault();
        const pageToGo = parseInt(this.state.gotoPage, 10);
        if (pageToGo >= 0 && pageToGo <= this.props.totalPages) {
            this.props.onPageChange(pageToGo);
        }
    };

    render() {
        const { currentPage, totalPages, onPageChange } = this.props;
        const hasPrev = currentPage > 1;
        const hasNext = currentPage < totalPages;
        return (
            <Segment className="pagination">
                <Grid columns={3} stretched>
                    <Grid.Column width={3} verticalAlign="middle">
                        <Button
                            fluid
                            primary
                            disabled={!hasPrev}
                            onClick={() => onPageChange(currentPage - 1)}
                        >
                            Previous
                        </Button>
                    </Grid.Column>
                    <Grid.Column width={10} textAlign="center" verticalAlign="middle">
                        <Form onSubmit={this.handleJumpToPage} inline>
                            <label> page:</label>
                            <Input
                                type="number"
                                min="1"
                                max={totalPages}
                                value={this.state.gotoPage}
                                onChange={(e, { value }) => this.setState({ gotoPage: value })}
                                className="pagination-input"
                            />
                            <label>of {totalPages} </label>
                            <Button primary type="submit">
                                Go
                            </Button>
                        </Form>
                    </Grid.Column>
                    <Grid.Column width={3} verticalAlign="middle">
                        <Button
                            fluid
                            primary
                            disabled={!hasNext}
                            onClick={() => onPageChange(currentPage + 1)}
                        >
                            Next
                        </Button>
                    </Grid.Column>
                </Grid>
            </Segment>
        );
    }
}

export default Pagination;

